import { useContext } from 'react';
import { useCallback } from 'react';
import { MarkNotificationAsReadRequestUserTypeEnum } from '../client-sdk/api';
import { HimmaContext } from '../Context/HimmaContext';
export const useAllMarkReadApi = () => {
  const api = useContext(HimmaContext)!;

  const getAllMarkRead = useCallback(
    async (query: { userId: string; userType: string; isRead: boolean }) => {
      if (!query || !query.userId || !query.userType) {
        throw new Error('Invalid query parameters');
      }
      const markNotificationAsReadRequest = {
       userId: query.userId,
        userType :query.userType as MarkNotificationAsReadRequestUserTypeEnum,
        isRead: true
      }
      const response = await api.markNotificationAsRead(markNotificationAsReadRequest);
      return response.data;
    },
    [api]
  );

  return { getAllMarkRead };
};